import TransportList from './TransportList/TransportList';

const Transport = () => {
  return (
    <>
      <TransportList />
    </>
  );
};

export default Transport;
